<div class="grid align-center margin-top">
  <div class="col-lg-2 ml-2 mr-2">
    <div class="box">
      <h1>{{ headerText }}</h1>
    </div>
  </div>
  @if (isDataLoadedforSchools) {
    <div>
      <div class="col-lg-4">
        <div class="box">
          <p-select
            [options]="schoolGroup"
            [(ngModel)]="selectedSchoolGroup"
            (onChange)="setSchoolContext()"
            optionLabel="label"
            id="schoolList"
            #dropdownSchoolList
          ></p-select>
        </div>
      </div>
    </div>
  }
</div>
